import * as z from "zod";

export const deleteConsolidationViewFolder = {
  name: "deleteConsolidationViewFolder" as const,
  input: z.object({ folderId: z.string() }),
  output: z.object({}),
};
